import { Entity } from "../entity.service";

export class AppProjectDate extends Entity {
  type = "app.project_dates";

  value: string;
}
